import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import SiteFooter from '../shared/SiteFooter';
import './legal.css';

// Renders an <a> from markdown as a router <Link> when it points at an
// internal route, otherwise as a normal anchor (mailto:, external, etc.).
const MarkdownLink = ({ href, children }) => {
  if (href && href.startsWith('/')) {
    return <Link to={href}>{children}</Link>;
  }
  return <a href={href} target={href?.startsWith('mailto:') ? undefined : '_blank'} rel="noopener noreferrer">{children}</a>;
};

const markdownComponents = { a: MarkdownLink };

// Shared shell for the static legal pages (/privacy, /terms, /contact).
// Keeps page chrome (nav, width constraint, footer, contact cross-link)
// separate from the approved copy itself, which lives in legalContent.js.
const LegalPage = ({ markdown, showContactLink = true }) => (
  <div className="legal-page">
    <nav className="legal-nav">
      <Link to="/" className="legal-nav-brand">
        <span className="legal-nav-logomark">Z</span>
        <span className="legal-nav-wordmark">ZYNACULAR</span>
      </Link>
      <Link to="/" className="legal-nav-back">← Back to home</Link>
    </nav>

    <main className="legal-content">
      <article className="legal-prose">
        <ReactMarkdown components={markdownComponents}>{markdown}</ReactMarkdown>
      </article>

      {showContactLink && (
        <p className="legal-contact-crosslink">
          Have a question? <Link to="/contact">Contact us</Link>.
        </p>
      )}
    </main>

    <SiteFooter />
  </div>
);

export default LegalPage;
